import { SetState } from 'zustand';
import type { InstallMeterStore } from '../../useStore';

export enum SensorLoraState {
  OK,
  NotResponding,
  NotInDatabase,
  NotRegistered,
}

const INITIAL_STATE: SensorLoraForm = {
  sensorLoraState: undefined,
};

export interface SensorLoraForm {
  sensorLoraState?: SensorLoraState;
}

export type SensorLoraStepSlice = SensorLoraForm & {
  resetSensorLoraStepSlice: (initValues?: Partial<SensorLoraForm>) => void;
  setSensorLoraStepValues: (values: SensorLoraForm) => void;
  setSensorLoraState: (sensorState: SensorLoraState) => void;
};

export const createSensorLoraStepSlice = (set: SetState<InstallMeterStore>): SensorLoraStepSlice => ({
  ...INITIAL_STATE,
  resetSensorLoraStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
  setSensorLoraStepValues: (values: SensorLoraForm) => set(values),
  setSensorLoraState: (payload?: SensorLoraState) =>
    set(() => ({
      sensorLoraState: payload,
    })),
});
